import { LoggedOutDevAIFree } from "./free";

export const LoggedOutDevAI = () => {
    return <LoggedOutDevAIFree />;
};
